import React, { useState, useRef, useEffect } from 'react'
import { useHistory, useParams, Link } from 'react-router-dom'
import {
  HttpService,
  API,
  SimpleReactValidator,
  Title,
  toast,
  Messages,
  FileUploadWithPreview,
  Common,
  Permissionkeys,
  getBase64,
  Spinner,
  DropdownTreeSelect
} from '../../../config/react'
import 'react-summernote/dist/react-summernote.css'

const AddBanner = () => {
  const urlParams = useParams()
  const history = useHistory()
  const [IsAuth, setIsAuth] = useState(false)
  const [loading, setLoading] = useState(true)
  const validator = useRef(
    new SimpleReactValidator({
      validators: {
        noDomain: {
          message: 'Custom links cannot contain a domain.',
          rule: (val) => !/^(https?:\/\/|www\.)/i.test(val), // Rejects if input contains a domain
          required: true
        }
      }
    })
  )
  const [isForceUpdate, setForceUpdate] = useState(false)
  const [DeskImg, setDeskImg] = useState('invalid')

  const [IsDesktopImage, setDesktopImage] = useState(true)
  const [IsDesktopValidFile, setDesktopValidFile] = useState(true)
  const [IsDesktopImageSize, setDesktopImageSize] = useState(false)
  // const [IsDesktopShowImageRemoveLink, setIsDesktopShowImageRemoveLink] = useState(false)

  const [MobileImg, setMobileImg] = useState('')
  const [IsMobileImage, setMobileImage] = useState(true)
  const [IsMobileValidFile, setMobileValidFile] = useState(true)
  const [IsMobileImageSize, setMobileImageSize] = useState(false)
  // const [IsMobileShowImageRemoveLink, setIsMobileShowImageRemoveLink] = useState(false)

  const [Categories, setCategories] = useState([])
  const [Categories2, setCategories2] = useState([])
  const [Pages, setPages] = useState([])

  const [Inputs, setInputs] = useState({
    id: 0,
    name: '',
    btn_text: '',
    btn_text_2: '',
    status: 0,
    prevDeskImg: '',
    prevMobImg: '',
    DesktopbtnX: '',
    DesktopbtnY: '',
    DesktopbtnX2: '',
    DesktopbtnY2: '',
    MobilebtnX: '',
    MobilebtnY: '',
    MobilebtnX2: '',
    MobilebtnY2: '',
    desk_btn_theme: 'white',
    mob_btn_theme: 'white',
    link_type: '',
    link: '',
    external_link: '',
    page_id: '',
    category_id: '',
    selectedCategoryId: '',
    link_type_2: '',
    link_2: '',
    external_link_2: '',
    page_id_2: '',
    category_id_2: '',
    selectedCategoryId_2: '',
    button_count: 'null'
  })

  // dynamic button
  const [DesktopBtnPosition, setDesktopBtnPosition] = useState(null)
  const [DesktopBtnPosition2, setDesktopBtnPosition2] = useState(null)
  const [MobileBtnPosition, setMobileBtnPosition] = useState(null)
  const [MobileBtnPosition2, setMobileBtnPosition2] = useState(null)
  const [desktopButtonCount, setDesktopButtonCount] = useState(0)
  const [mobileButtonCount, setMobileButtonCount] = useState(0)
  const [currentDesktopButtonBeingPositioned, setCurrentDesktopButtonBeingPositioned] =
    useState(null)
  const [currentMobileButtonBeingPositioned, setCurrentMobileButtonBeingPositioned] = useState(null)
  const [desktopHoverInfo, setDesktopHoverInfo] = useState(null)
  const [mobileHoverInfo, setMobileHoverInfo] = useState(null)
  const DesktopImageRef = useRef(null)
  const MobileImageRef = useRef(null)

  // Handle desktop image hover to show which button will be placed
  const handleDesktopImageHover = (event) => {
    if (!DesktopImageRef.current) return
    if (!Inputs.button_count || Inputs.button_count === 'null') {
      setDesktopHoverInfo(null)
      return
    }

    const rect = DesktopImageRef.current.getBoundingClientRect()
    const x = event.clientX - rect.left
    const y = event.clientY - rect.top

    const xPercentDesk = ((x / rect.width) * 100).toFixed(2)
    const yPercentDesk = ((y / rect.height) * 100).toFixed(2)

    const buttonCount = Number(Inputs.button_count)
    let buttonToPlace = null

    if (buttonCount === 1) {
      buttonToPlace = 1
    } else if (buttonCount === 2) {
      if (desktopButtonCount === 0) {
        buttonToPlace = 1
      } else if (desktopButtonCount === 1) {
        buttonToPlace = 2
      }
    }

    setDesktopHoverInfo({
      buttonNumber: buttonToPlace,
      xPercent: xPercentDesk,
      yPercent: yPercentDesk,
      x: x,
      y: y
    })
  }

  // Handle desktop image leave
  const handleDesktopImageLeave = () => {
    setDesktopHoverInfo(null)
  }

  const handleDesktopImageClick = (event) => {
    if (!DesktopImageRef.current) return
    if (!Inputs.button_count || Inputs.button_count === 'null') return

    const rect = DesktopImageRef.current.getBoundingClientRect()

    const x = event.clientX - rect.left
    const y = event.clientY - rect.top

    const xPercentDesk = String(((x / rect.width) * 100).toFixed(2))
    const yPercentDesk = String(((y / rect.height) * 100).toFixed(2))

    const buttonCount = Number(Inputs.button_count)

    // If only 1 button allowed
    if (buttonCount === 1) {
      setDesktopBtnPosition({ xPercentDesk, yPercentDesk })

      setInputs((prev) => ({
        ...prev,
        DesktopbtnX: xPercentDesk,
        DesktopbtnY: yPercentDesk
      }))

      setDesktopButtonCount(1)
      setCurrentDesktopButtonBeingPositioned(1)
      return
    }

    // If 2 buttons allowed
    if (buttonCount === 2) {
      if (desktopButtonCount === 0) {
        setDesktopBtnPosition({ xPercentDesk, yPercentDesk })

        setInputs((prev) => ({
          ...prev,
          DesktopbtnX: xPercentDesk,
          DesktopbtnY: yPercentDesk
        }))

        setDesktopButtonCount(1)
        setCurrentDesktopButtonBeingPositioned(1)
      } else {
        setDesktopBtnPosition2({ xPercentDesk, yPercentDesk })

        setInputs((prev) => ({
          ...prev,
          DesktopbtnX2: xPercentDesk,
          DesktopbtnY2: yPercentDesk
        }))

        setDesktopButtonCount(2)
        setCurrentDesktopButtonBeingPositioned(2)
      }
    }
  }

  // Handle mobile image hover to show which button will be placed
  const handleMobileImageHover = (event) => {
    if (!MobileImageRef.current) return
    if (!Inputs.button_count || Inputs.button_count === 'null') {
      setMobileHoverInfo(null)
      return
    }

    const rect = MobileImageRef.current.getBoundingClientRect()
    const x = event.clientX - rect.left
    const y = event.clientY - rect.top

    const xPercentMob = ((x / rect.width) * 100).toFixed(2)
    const yPercentMob = ((y / rect.height) * 100).toFixed(2)

    const buttonCount = Number(Inputs.button_count)
    let buttonToPlace = null

    if (buttonCount === 1) {
      buttonToPlace = 1
    } else if (buttonCount === 2) {
      if (mobileButtonCount === 0) {
        buttonToPlace = 1
      } else if (mobileButtonCount === 1) {
        buttonToPlace = 2
      }
    }

    setMobileHoverInfo({
      buttonNumber: buttonToPlace,
      xPercent: xPercentMob,
      yPercent: yPercentMob,
      x: x,
      y: y
    })
  }

  // Handle mobile image leave
  const handleMobileImageLeave = () => {
    setMobileHoverInfo(null)
  }

  // mobile btn - handles multiple buttons based on button_count
  const handleMobileImageClick = (event) => {
    if (!MobileImageRef.current) return
    if (!Inputs.button_count || Inputs.button_count === 'null') return

    const rect = MobileImageRef.current.getBoundingClientRect()

    const x = event.clientX - rect.left
    const y = event.clientY - rect.top

    const xPercentMob = String(((x / rect.width) * 100).toFixed(2))
    const yPercentMob = String(((y / rect.height) * 100).toFixed(2))

    // If only 1 button allowed
    if (Number(Inputs.button_count) === 1) {
      setMobileBtnPosition({ xPercentMob, yPercentMob })

      setInputs((prev) => ({
        ...prev,
        MobilebtnX: xPercentMob,
        MobilebtnY: yPercentMob
      }))

      setMobileButtonCount(1)
      setCurrentMobileButtonBeingPositioned(1)
      return
    }

    // If 2 buttons allowed
    if (Number(Inputs.button_count) === 2) {
      if (mobileButtonCount === 0) {
        setMobileBtnPosition({ xPercentMob, yPercentMob })

        setInputs((prev) => ({
          ...prev,
          MobilebtnX: xPercentMob,
          MobilebtnY: yPercentMob
        }))

        setMobileButtonCount(1)
        setCurrentMobileButtonBeingPositioned(1)
      } else {
        setMobileBtnPosition2({ xPercentMob, yPercentMob })

        setInputs((prev) => ({
          ...prev,
          MobilebtnX2: xPercentMob,
          MobilebtnY2: yPercentMob
        }))

        setMobileButtonCount(2)
        setCurrentMobileButtonBeingPositioned(2)
      }
    }
  }

  // Remove desktop button
  const handleRemoveDesktopButton = (buttonIndex) => {
    if (buttonIndex === 1) {
      // If only 1 button exists
      if (desktopButtonCount === 1) {
        setDesktopBtnPosition(null)
        setDesktopButtonCount(0)
        setCurrentDesktopButtonBeingPositioned(null)

        setInputs((prev) => ({
          ...prev,
          DesktopbtnX: '',
          DesktopbtnY: ''
        }))
        return
      }

      // If 2 buttons exist → shift 2nd to 1st
      if (desktopButtonCount === 2) {
        setDesktopBtnPosition(DesktopBtnPosition2)
        setDesktopBtnPosition2(null)
        setDesktopButtonCount(1)
        setCurrentDesktopButtonBeingPositioned(1)

        setInputs((prev) => ({
          ...prev,
          DesktopbtnX: prev.DesktopbtnX2,
          DesktopbtnY: prev.DesktopbtnY2,
          DesktopbtnX2: '',
          DesktopbtnY2: ''
        }))
      }
    }

    if (buttonIndex === 2) {
      setDesktopBtnPosition2(null)
      setDesktopButtonCount(1)
      setCurrentDesktopButtonBeingPositioned(1)

      setInputs((prev) => ({
        ...prev,
        DesktopbtnX2: '',
        DesktopbtnY2: ''
      }))
    }
  }

  // Remove mobile button
  const handleRemoveMobileButton = (buttonIndex) => {
    if (buttonIndex === 1) {
      // If only 1 button exists
      if (mobileButtonCount === 1) {
        setMobileBtnPosition(null)
        setMobileButtonCount(0)
        setCurrentMobileButtonBeingPositioned(null)

        setInputs((prev) => ({
          ...prev,
          MobilebtnX: '',
          MobilebtnY: ''
        }))
        return
      }

      // If 2 buttons exist → shift 2nd to 1st
      if (mobileButtonCount === 2) {
        setMobileBtnPosition(MobileBtnPosition2)
        setMobileBtnPosition2(null)
        setMobileButtonCount(1)
        setCurrentMobileButtonBeingPositioned(1)

        setInputs((prev) => ({
          ...prev,
          MobilebtnX: prev.MobilebtnX2,
          MobilebtnY: prev.MobilebtnY2,
          MobilebtnX2: '',
          MobilebtnY2: ''
        }))
      }
    }

    if (buttonIndex === 2) {
      setMobileBtnPosition2(null)
      setMobileButtonCount(1)
      setCurrentMobileButtonBeingPositioned(1)

      setInputs((prev) => ({
        ...prev,
        MobilebtnX2: '',
        MobilebtnY2: ''
      }))
    }
  }

  // Handle button count dropdown change
  const handleButtonCountChange = (e) => {
    const newCount = e.target.value
    setInputs({ ...Inputs, button_count: newCount })
    if (newCount === 'null') {
      setDesktopButtonCount(0)
      setMobileButtonCount(0)
      setDesktopBtnPosition(null)
      setDesktopBtnPosition2(null)
      setMobileBtnPosition(null)
      setMobileBtnPosition2(null)
      setCurrentDesktopButtonBeingPositioned(null)
      setCurrentMobileButtonBeingPositioned(null)
      setInputs({
        ...Inputs,
        button_count: newCount,
        DesktopbtnX: '',
        DesktopbtnY: '',
        DesktopbtnX2: '',
        DesktopbtnY2: '',
        MobilebtnX: '',
        MobilebtnY: '',
        MobilebtnX2: '',
        MobilebtnY2: ''
      })
    }
    setForceUpdate(!isForceUpdate)
  }

  useEffect(() => {
    if (!Common.validatePermission(Permissionkeys.Widgets)) {
      history.push('/')
    }
    GetCategoryList()
    setIsAuth(true)
    setLoading(false)
    setForceUpdate(!isForceUpdate)
    document.title = Title.AddBanner
    if (urlParams.id !== undefined) {
      document.title = Title.EditBanner
      GetBannerDetail()
    } else {
      setTimeout(() => {
        initDesktopImagePlugin()
        initMobileImagePlugin()
      }, 500)
    }
    GetPageList()
  }, [urlParams.id])

  const GetPageList = () => {
    HttpService.getApi(API.GetContentManagementList).then((response) => {
      setPages(response.data.result)
    })
  }
  const GetCategoryList = (selected = { first: null, second: null }) => {
    HttpService.postApi(API.GetCategory, null).then((response) => {
      if (!response.data.result) return

      const data = response.data.result[0]

      // filter parent category
      const parentCategories = data.filter((x) => x.parent_id === 1 && x.status)

      const categories = []
      const categories2 = []

      parentCategories.map((item) => {
        /* ================= FIRST DROPDOWN ================= */

        const filteredSubcategories = data.filter((x) => x.parent_id === item.id && x.status)
        const subcategories = []

        filteredSubcategories.map((subitem) => {
          const filteredSubChildCategories = data.filter(
            (x) => x.parent_id === subitem.id && x.status
          )
          const subchildcategories = []

          filteredSubChildCategories.map((subchilditem) => {
            const filteredChildCategories = data.filter(
              (x) => x.parent_id === subchilditem.id && x.status
            )
            const childcategories = []

            filteredChildCategories.map((childitem) => {
              const filteredChildrenCategories = data.filter(
                (x) => x.parent_id === childitem.id && x.status
              )
              const childrencategories = []

              filteredChildrenCategories.map((childrenitem) => {
                childrencategories.push({
                  label: childrenitem.name,
                  value: childrenitem.id,
                  checked: selected.first === childrenitem.id
                })
                return true
              })

              childcategories.push({
                label: childitem.name,
                value: childitem.id,
                checked: selected.first === childitem.id,
                children: childrencategories
              })
              return true
            })

            subchildcategories.push({
              label: subchilditem.name,
              value: subchilditem.id,
              checked: selected.first === subchilditem.id,
              children: childcategories
            })
            return true
          })

          subcategories.push({
            label: subitem.name,
            value: subitem.id,
            checked: selected.first === subitem.id,
            children: subchildcategories
          })
          return true
        })

        categories.push({
          label: item.name,
          value: item.id,
          checked: selected.first === item.id,
          children: subcategories
        })

        /* ================= SECOND DROPDOWN ================= */

        const filteredSubcategories2 = data.filter((x) => x.parent_id === item.id && x.status)
        const subcategories2 = []

        filteredSubcategories2.map((subitem) => {
          const filteredSubChildCategories2 = data.filter(
            (x) => x.parent_id === subitem.id && x.status
          )
          const subchildcategories2 = []

          filteredSubChildCategories2.map((subchilditem) => {
            const filteredChildCategories2 = data.filter(
              (x) => x.parent_id === subchilditem.id && x.status
            )
            const childcategories2 = []

            filteredChildCategories2.map((childitem) => {
              const filteredChildrenCategories2 = data.filter(
                (x) => x.parent_id === childitem.id && x.status
              )
              const childrencategories2 = []

              filteredChildrenCategories2.map((childrenitem) => {
                childrencategories2.push({
                  label: childrenitem.name,
                  value: childrenitem.id,
                  checked: selected.second === childrenitem.id
                })
                return true
              })

              childcategories2.push({
                label: childitem.name,
                value: childitem.id,
                checked: selected.second === childitem.id,
                children: childrencategories2
              })
              return true
            })

            subchildcategories2.push({
              label: subchilditem.name,
              value: subchilditem.id,
              checked: selected.second === subchilditem.id,
              children: childcategories2
            })
            return true
          })

          subcategories2.push({
            label: subitem.name,
            value: subitem.id,
            checked: selected.second === subitem.id,
            children: subchildcategories2
          })
          return true
        })

        categories2.push({
          label: item.name,
          value: item.id,
          checked: selected.second === item.id,
          children: subcategories2
        })

        return true
      })

      setCategories(categories)
      setCategories2(categories2)
    })
  }

  const updateCategoryDropdown = () => {
    Categories.map((item, index) => {
      if (item.value === Inputs.category_id) {
        Categories[index].checked = true
      } else {
        Categories[index].checked = false
      }
      if (item.children) {
        item.children.map((subitem, subindex) => {
          if (subitem.value === Inputs.category_id) {
            Categories[index].children[subindex].checked = true
          } else {
            Categories[index].children[subindex].checked = false
          }
          if (subitem.children) {
            subitem.children.map((firstlevelsubitem, firstlevelsubindex) => {
              if (firstlevelsubitem.value === Inputs.category_id) {
                Categories[index].children[subindex].children[firstlevelsubindex].checked = true
              } else {
                Categories[index].children[subindex].children[firstlevelsubindex].checked = false
              }
              if (firstlevelsubitem.children) {
                firstlevelsubitem.children.map((secondlevelsubitem, secondlevelsubindex) => {
                  if (secondlevelsubitem.value === Inputs.category_id) {
                    Categories[index].children[subindex].children[firstlevelsubindex].children[
                      secondlevelsubindex
                    ].checked = true
                  } else {
                    Categories[index].children[subindex].children[firstlevelsubindex].children[
                      secondlevelsubindex
                    ].checked = false
                  }
                  return true
                })
              }
              return true
            })
          }
          return true
        })
      }
      return true
    })
  }

  const updateCategoryDropdown2 = () => {
    Categories2.map((item, index) => {
      if (item.value === Inputs.category_id_2) {
        Categories2[index].checked = true
      } else {
        Categories2[index].checked = false
      }
      if (item.children) {
        item.children.map((subitem, subindex) => {
          if (subitem.value === Inputs.category_id_2) {
            Categories2[index].children[subindex].checked = true
          } else {
            Categories2[index].children[subindex].checked = false
          }
          if (subitem.children) {
            subitem.children.map((firstlevelsubitem, firstlevelsubindex) => {
              if (firstlevelsubitem.value === Inputs.category_id_2) {
                Categories2[index].children[subindex].children[firstlevelsubindex].checked = true
              } else {
                Categories2[index].children[subindex].children[firstlevelsubindex].checked = false
              }
              if (firstlevelsubitem.children) {
                firstlevelsubitem.children.map((secondlevelsubitem, secondlevelsubindex) => {
                  if (secondlevelsubitem.value === Inputs.category_id_2) {
                    Categories2[index].children[subindex].children[firstlevelsubindex].children[
                      secondlevelsubindex
                    ].checked = true
                  } else {
                    Categories2[index].children[subindex].children[firstlevelsubindex].children[
                      secondlevelsubindex
                    ].checked = false
                  }
                  return true
                })
              }
              return true
            })
          }
          return true
        })
      }
      return true
    })
  }

  const onChangeCategory = (currentNode, selectedNodes) => {
    if (selectedNodes.length > 0) {
      setInputs({ ...Inputs, selectedCategoryId: selectedNodes[0].value })
      Inputs.selectedCategoryId = Inputs.category_id = selectedNodes[0].value
    } else {
      setInputs({ ...Inputs, selectedCategoryId: '' })
    }
    updateCategoryDropdown()
  }
  const onChangeCategory2 = (currentNode, selectedNodes) => {
    if (selectedNodes.length > 0) {
      setInputs({ ...Inputs, selectedCategoryId_2: selectedNodes[0].value })
      Inputs.selectedCategoryId_2 = Inputs.category_id_2 = selectedNodes[0].value
    } else {
      setInputs({ ...Inputs, selectedCategoryId_2: '' })
    }
    updateCategoryDropdown2()
  }

  const GetBannerDetail = () => {
    const param = {
      id: urlParams.id
    }
    setLoading(true)
    HttpService.postApi(API.GetBanner, param).then((response) => {
      setLoading(false)
      if (response.data.result) {
        const data = response.data.result[0][0]

        setInputs({ id: data.id, name: data.name, status: data.status })
        if (data.desktop_main_image !== '') {
          initDesktopImagePlugin(data.desktop_main_image)
        } else {
          initDesktopImagePlugin()
        }
        if (data.mobile_main_image !== '') {
          initMobileImagePlugin(data.mobile_main_image)
        } else {
          initMobileImagePlugin()
        }
        if (data !== null && data !== undefined) {
          const xPercentDesk = data.desk_btn_x_position
          const yPercentDesk = data.desk_btn_y_position
          const xPercentDesk2 = data.desk_btn_x_position_2
          const yPercentDesk2 = data.desk_btn_y_position_2
          const xPercentMob = data.mob_btn_x_position
          const yPercentMob = data.mob_btn_y_position
          const xPercentMob2 = data.mob_btn_x_position_2
          const yPercentMob2 = data.mob_btn_y_position_2
          const buttonCount = data.button_count || 'null'

          setInputs({
            ...Inputs,
            btn_text: data.btn_text,
            btn_text_2: data.btn_text_2 || '',
            name: data.name,
            status: data.status,
            prevMobImg: data.mobile_main_image,
            prevDeskImg: data.desktop_main_image,
            link_type: data.link_type,
            link: data.link_type === 'custom_link' ? data.link : 0,
            external_link: data.link_type === 'external_link' ? data.link : 0,
            page_id: data.page_id,
            selectedCategoryId: data.category_id,
            MobilebtnX: xPercentMob,
            MobilebtnY: yPercentMob,
            MobilebtnX2: xPercentMob2,
            MobilebtnY2: yPercentMob2,
            DesktopbtnX: xPercentDesk,
            DesktopbtnY: yPercentDesk,
            DesktopbtnX2: xPercentDesk2,
            DesktopbtnY2: yPercentDesk2,
            desk_btn_theme:
              data.desk_btn_theme !== null ? data.desk_btn_theme : Inputs.desk_btn_theme,
            mob_btn_theme: data.mob_btn_theme !== null ? data.mob_btn_theme : Inputs.mob_btn_theme,
            button_count: buttonCount,
            link_type_2: data.link_type_2,
            link_2: data.link_type_2 === 'custom_link' ? data.link_2 : 0,
            page_id_2: data.page_id_2,
            external_link_2: data.link_type_2 === 'external_link' ? data.link_2 : 0,
            selectedCategoryId_2: data.category_id_2
          })

          if (xPercentDesk) {
            setDesktopBtnPosition({
              xPercentDesk: String(xPercentDesk),
              yPercentDesk: String(yPercentDesk)
            })
            setDesktopButtonCount(1)
            setCurrentDesktopButtonBeingPositioned(1)
          }
          if (xPercentDesk2) {
            setDesktopBtnPosition2({
              xPercentDesk: String(xPercentDesk2),
              yPercentDesk: String(yPercentDesk2)
            })
            if (xPercentDesk) {
              setDesktopButtonCount(2)
              setCurrentDesktopButtonBeingPositioned(2)
            }
          }
          if (xPercentMob) {
            setMobileBtnPosition({
              xPercentMob: String(xPercentMob),
              yPercentMob: String(yPercentMob)
            })
            setMobileButtonCount(1)
            setCurrentMobileButtonBeingPositioned(1)
          }
          if (xPercentMob2) {
            setMobileBtnPosition2({
              xPercentMob: String(xPercentMob2),
              yPercentMob: String(yPercentMob2)
            })
            if (xPercentMob) {
              setMobileButtonCount(2)
              setCurrentMobileButtonBeingPositioned(2)
            }
          }
          GetCategoryList({
            first: data.category_id,
            second: data.category_id_2
          })
        }
      }
    })
  }
  const handleInputChanges = (e) => {
    const field = e.target.name
    const fieldval = e.target.value
    if (field === 'status') Inputs[field] = e.target.checked
    else Inputs[field] = fieldval
    setForceUpdate(!isForceUpdate)
  }

  const SubmitForm = (e) => {
    if (DeskImg === 'invalid') {
      setDesktopImage(false)
    }
    console.log(validator.current)
    if (
      !validator.current.allValid() ||
      DeskImg === 'invalid' ||
      IsDesktopImage === false ||
      IsDesktopImageSize === true ||
      IsDesktopValidFile === false
    ) {
      validator.current.showMessages()
      setForceUpdate(!isForceUpdate)
      return
    }
    const param = {
      _id: urlParams.id !== undefined && urlParams.id !== null ? urlParams.id : Inputs.id,
      _name: Inputs.name.trim(),
      _desktop_main_image: DeskImg,
      _mobile_main_image: MobileImg,
      _status: Inputs.status ? 1 : 0,
      _desk_btnX: DesktopBtnPosition ? DesktopBtnPosition.xPercentDesk : Inputs.DesktopbtnX,
      _desk_btnY: DesktopBtnPosition ? DesktopBtnPosition.yPercentDesk : Inputs.DesktopbtnY,
      _desk_btnX2: DesktopBtnPosition2 ? DesktopBtnPosition2.xPercentDesk : Inputs.DesktopbtnX2,
      _desk_btnY2: DesktopBtnPosition2 ? DesktopBtnPosition2.yPercentDesk : Inputs.DesktopbtnY2,
      _Mob_btnX: MobileBtnPosition ? MobileBtnPosition.xPercentMob : Inputs.MobilebtnX,
      _Mob_btnY: MobileBtnPosition ? MobileBtnPosition.yPercentMob : Inputs.MobilebtnY,
      _Mob_btnX2: MobileBtnPosition2 ? MobileBtnPosition2.xPercentMob : Inputs.MobilebtnX2,
      _Mob_btnY2: MobileBtnPosition2 ? MobileBtnPosition2.yPercentMob : Inputs.MobilebtnY2,
      _link:
        Inputs.link_type === 'custom_link'
          ? Inputs.link === 0
            ? ''
            : Inputs.link
          : Inputs.link_type === 'external_link'
            ? Inputs.external_link === 0
              ? ''
              : Inputs.external_link
            : Inputs.link,
      _link_type: Inputs.link_type,
      _category_id: Inputs.selectedCategoryId,
      _page_id: Inputs.page_id,
      _desk_btn_theme: Inputs.desk_btn_theme,
      _mob_btn_theme: Inputs.mob_btn_theme,
      _btn_text: Inputs.btn_text,
      _btn_text_2: Inputs.btn_text_2,
      _button_count: Inputs.button_count,
      _link_type_2: Inputs.link_type_2,
      _link_2:
        Inputs.link_type_2 === 'custom_link'
          ? Inputs.link_2 || ''
          : Inputs.link_type_2 === 'external_link'
            ? Inputs.external_link_2 || ''
            : '',
      _category_id_2: Inputs.selectedCategoryId_2,
      _page_id_2: Inputs.page_id_2
    }
    setLoading(true)
    HttpService.postApi(API.SetBanner, param).then((response) => {
      if (response.data.message) {
        toast.warning(response.data.message)
        setLoading(false)
        initDesktopImagePlugin(DeskImg)
        initMobileImagePlugin(MobileImg)
        setForceUpdate(!isForceUpdate)
        return
      }
      validator.current.hideMessages()
      setForceUpdate(!isForceUpdate)
      if (response.data.result[0][0].result === 1) {
        setTimeout(() => {
          history.push('/widgets/banner')
          setLoading(false)
          if (urlParams.id === undefined) toast.success(Messages.RecordAdded)
          else toast.success(Messages.RecordUpdated)
        }, 8000)
      }
    })
  }
  const initMobileImagePlugin = (image1 = null) => {
    if (image1 !== '' && image1 !== null) {
      new FileUploadWithPreview('mobileimage', {
        text: {
          chooseFile: 'Choose Image...'
        },
        presetFiles: [image1]
      })
      setMobileImage(true)
    } else {
      new FileUploadWithPreview('mobileimage', {
        text: {
          chooseFile: 'Choose Image...'
        }
      })
    }
  }
  const initDesktopImagePlugin = (image = null) => {
    if (image !== '' && image !== null) {
      new FileUploadWithPreview('desktopimage', {
        text: {
          chooseFile: 'Choose Image...'
        },
        presetFiles: [image]
      })
      setDesktopImage(true)
    } else {
      new FileUploadWithPreview('desktopimage', {
        text: {
          chooseFile: 'Choose Image...'
        }
      })
    }
  }
  window.addEventListener('fileUploadWithPreview:imagesAdded', function (e) {
    if (e.detail.uploadId === 'desktopimage') {
      const imageType = e.detail.cachedFileArray[0].type

      const size = e.detail.cachedFileArray[0].size
      if (
        imageType === 'image/jpeg' ||
        imageType === 'image/jpg' ||
        imageType === 'image/png' ||
        imageType === 'image/webp'
      ) {
        if (size <= 2097152) {
          getBase64(e.detail.cachedFileArray[0], (result) => {
            setDeskImg(result)
          })
          setDesktopImage(true)
          setDesktopValidFile(true)
          setDesktopImageSize(false)
        } else {
          setDesktopImageSize(true)

          setDesktopImage(true)
          setDeskImg('')
        }
      } else {
        setDeskImg('')
        setDesktopImage(true)
        setDesktopValidFile(false)
        setDesktopImageSize(false)
      }
    } else if (e.detail.uploadId === 'mobileimage') {
      const imageType = e.detail.cachedFileArray[0].type
      const size = e.detail.cachedFileArray[0].size

      if (
        imageType === 'image/jpeg' ||
        imageType === 'image/jpg' ||
        imageType === 'image/png' ||
        imageType === 'image/webp'
      ) {
        if (size <= 2097152) {
          getBase64(e.detail.cachedFileArray[0], (result) => {
            setMobileImg(result)
          })
          setMobileImage(true)
          setMobileValidFile(true)
          setMobileImageSize(false)
        } else {
          setMobileImageSize(true)
        }
      } else {
        setMobileImg('')
        setMobileImage(true)
        setMobileValidFile(false)
        setMobileImageSize(false)
      }
    }
  })
  window.addEventListener('fileUploadWithPreview:clearButtonClicked', function (e) {
    if (e.detail.uploadId === 'desktopimage') {
      setDeskImg('')
      setDesktopValidFile(true)
      setDesktopImageSize(false)
      setDesktopImage(false)
    } else if (e.detail.uploadId === 'mobileimage') {
      setMobileImg('')
      setMobileValidFile(true)
      setMobileImageSize(false)
    }
  })

  // const handleMenuInputChanges = (e) => {
  //   setInputs({ ...Inputs, link_type: e.target.value })
  //   if (e.target.value === 'category') {
  //     setInputs({
  //       ...Inputs,
  //       page_id: Inputs.page_id === '' ? 0 : Inputs.page_id,
  //       link: Inputs.link === '' ? 0 : Inputs.link,
  //       selectedCategoryId: Inputs.selectedCategoryId === 0 ? '' : Inputs.selectedCategoryId,
  //       external_link: Inputs.external_link === '' ? 0 : Inputs.external_link,
  //       link_type: e.target.value
  //     })
  //   } else if (e.target.value === 'page') {
  //     setInputs({
  //       ...Inputs,
  //       link: Inputs.link === '' ? 0 : Inputs.link,
  //       selectedCategoryId: Inputs.selectedCategoryId === '' ? 0 : Inputs.selectedCategoryId,
  //       external_link: Inputs.external_link === '' ? 0 : Inputs.external_link,
  //       page_id: Inputs.page_id === 0 ? '' : Inputs.page_id,
  //       link_type: e.target.value
  //     })
  //   } else if (e.target.value === 'custom_link') {
  //     setInputs({
  //       ...Inputs,
  //       page_id: Inputs.page_id === '' ? 0 : Inputs.page_id,
  //       selectedCategoryId: Inputs.selectedCategoryId === '' ? 0 : Inputs.selectedCategoryId,
  //       link: Inputs.link === 0 ? '' : Inputs.link,
  //       link_type: e.target.value,
  //       external_link: Inputs.external_link === '' ? 0 : Inputs.external_link
  //     })
  //   } else if (e.target.value === 'blank') {
  //     setInputs({
  //       ...Inputs,
  //       page_id: 0,
  //       selectedCategoryId: 0,
  //       link: 0,
  //       link_type: e.target.value,
  //       external_link: 0
  //     })
  //   } else if (e.target.value === 'external_link') {
  //     setInputs({
  //       ...Inputs,
  //       page_id: Inputs.page_id === '' ? 0 : Inputs.page_id,
  //       selectedCategoryId: Inputs.selectedCategoryId === '' ? 0 : Inputs.selectedCategoryId,
  //       external_link: Inputs.external_link === 0 ? '' : Inputs.external_link,
  //       link: Inputs.link === '' ? 0 : Inputs.link,
  //       link_type: e.target.value
  //     })
  //   }
  //   setForceUpdate(!isForceUpdate)
  // }

  const handleMenuInputChanges = (e, buttonIndex = 1) => {
    const value = e.target.value

    if (buttonIndex === 1) {
      setInputs((prev) => ({
        ...prev,
        link_type: value,

        page_id: value === 'page' ? (prev.page_id === 0 ? '' : prev.page_id) : 0,

        selectedCategoryId:
          value === 'category' ? (prev.selectedCategoryId === 0 ? '' : prev.selectedCategoryId) : 0,

        link: value === 'custom_link' ? (prev.link === 0 ? '' : prev.link) : 0,

        external_link:
          value === 'external_link' ? (prev.external_link === 0 ? '' : prev.external_link) : 0
      }))
    }

    if (buttonIndex === 2) {
      setInputs((prev) => ({
        ...prev,
        link_type_2: value,

        page_id_2: value === 'page' ? (prev.page_id_2 === 0 ? '' : prev.page_id_2) : 0,

        selectedCategoryId_2:
          value === 'category'
            ? prev.selectedCategoryId_2 === 0
              ? ''
              : prev.selectedCategoryId_2
            : 0,

        link_2: value === 'custom_link' ? (prev.link_2 === 0 ? '' : prev.link_2) : 0,

        external_link_2:
          value === 'external_link' ? (prev.external_link_2 === 0 ? '' : prev.external_link_2) : 0
      }))
    }

    setForceUpdate((prev) => !prev)
  }

  return !IsAuth || loading ? (
    <Spinner />
  ) : (
    <div className="content-wrapper pb-0">
      <div className="page-header">
        <h3 className="page-title mb-0">
          {' '}
          {urlParams.id !== undefined ? Title.EditBanner : Title.AddBanner}{' '}
        </h3>
        <div className="btn-group">
          <button
            type="button"
            className="btn btn-dark btn-fw rounded mr-2"
            onClick={history.goBack}
          >
            {' '}
            Back{' '}
          </button>
        </div>
      </div>
      <div className="row">
        <div className="col-12 grid-margin stretch-card">
          <div className="card">
            <div className="card-body">
              <form className="forms-sample">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Name</label>
                      <input
                        type="text"
                        className="form-control"
                        name="name"
                        onChange={handleInputChanges}
                        onKeyUp={handleInputChanges}
                        defaultValue={Inputs.name}
                        placeholder="Name"
                      />
                      {validator.current.message('Name', Inputs.name, 'required|max:255', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        htmlFor="exampleInputUsername2"
                        className="col-sm-12"
                      >
                        Status
                      </label>
                      <div className="col-sm-12">
                        <div className="custom-control custom-switch mt-1">
                          <input
                            type="checkbox"
                            className="custom-control-input"
                            name="status"
                            onChange={handleInputChanges}
                            id="EnableProduct"
                            checked={Inputs.status}
                          />
                          <label
                            className="custom-control-label"
                            htmlFor="EnableProduct"
                          >
                            {' '}
                          </label>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="row widget-banner-row">
                  <div className="col-md-6 col-lg-6">
                    <h5>
                      <b>Desktop Banners</b>
                    </h5>
                    <div className="mt-3 mb-4">
                      <div
                        className="custom-file-container"
                        data-upload-id="desktopimage"
                      >
                        <label>Desktop Banner</label>
                        <label className="note ml-1">
                          {' '}
                          {'(Only PNG, JPEG, JPG format allowed. Size should be 1920x820 pixels.)'}
                        </label>
                      </div>
                      <div
                        style={!IsDesktopValidFile ? {} : { display: 'none' }}
                        className="error pt-2 mt-0 pl-3 pb-3"
                      >
                        {Messages.formatnotsupport}
                      </div>
                      <div
                        style={IsDesktopImageSize ? {} : { display: 'none' }}
                        className="error pt-0 mt-0 pl-3 pb-2"
                      >
                        Maximum file size should be 2MB.
                      </div>
                      <div
                        style={IsDesktopImage ? { display: 'none' } : {}}
                        className="error pt-2 mt-0 pl-3 pb-3"
                      >
                        Desktop Image is required.
                      </div>
                    </div>
                    <div></div>
                  </div>
                  <div className="col-md-6 col-lg-6">
                    <h5>
                      <b>Mobile Banners</b>
                    </h5>
                    <div className="mt-3 mb-4">
                      <div
                        className="custom-file-container mb-3"
                        data-upload-id="mobileimage"
                      >
                        <label>Mobile Banner</label>
                        <label className="note ml-1">
                          {' '}
                          {'(Only PNG, JPEG, JPG format allowed. Size should be 767x375 pixels.)'}
                        </label>
                      </div>
                      <div style={IsMobileImage ? { display: 'none' } : { display: 'block' }}>
                        <small className="error">Image is required.</small>
                      </div>
                      <div
                        style={!IsMobileValidFile ? {} : { display: 'none' }}
                        className="error pt-2 pb-3 mt-0 pl-3"
                      >
                        {Messages.formatnotsupport}
                      </div>
                      <div
                        style={IsMobileImageSize ? {} : { display: 'none' }}
                        className="error pt-0 pb-2 mt-0 pl-3"
                      >
                        Maximum file size should be 2MB.
                      </div>
                    </div>
                    <div></div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Button Count</label>
                      <select
                        className="form-control"
                        name="button_count"
                        onChange={handleButtonCountChange}
                        value={Inputs.button_count}
                      >
                        <option value="null">No Button</option>
                        <option value="1">Single Button</option>
                        <option value="2">Double Button</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Desktop Button Theme</label>
                      <select
                        className="form-control"
                        name="desk_btn_theme"
                        onChange={handleInputChanges}
                        value={Inputs.desk_btn_theme}
                        disabled={Inputs.button_count === 'null'}
                      >
                        <option value={'black'}>Black</option>
                        <option value={'white'}>White</option>
                        <option value={'theme_color'}>Theme color</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-4">
                    <div className="form-group">
                      <label>Mobile Button Theme</label>
                      <select
                        className="form-control"
                        name="mob_btn_theme"
                        onChange={handleInputChanges}
                        value={Inputs.mob_btn_theme}
                        disabled={Inputs.button_count === 'null'}
                      >
                        <option value={'black'}>Black</option>
                        <option value={'white'}>White</option>
                        <option value={'theme_color'}>Theme color</option>
                      </select>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Button 1 Text</label>
                      <input
                        type="text"
                        className="form-control"
                        name="btn_text"
                        onChange={handleInputChanges}
                        onKeyUp={handleInputChanges}
                        defaultValue={Inputs.btn_text}
                        placeholder="Button 1 Text"
                        disabled={Inputs.button_count === 'null'}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Button 2 Text</label>
                      <input
                        type="text"
                        className="form-control"
                        name="btn_text_2"
                        onChange={handleInputChanges}
                        onKeyUp={handleInputChanges}
                        defaultValue={Inputs.btn_text_2}
                        placeholder="Button 2 Text"
                        disabled={Inputs.button_count === '1' || Inputs.button_count === 'null'}
                      />
                    </div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Link Type</label>
                      <select
                        className="form-control"
                        name="link_type"
                        onChange={(e) => handleMenuInputChanges(e, 1)}
                        value={Inputs.link_type}
                      >
                        <option value="">Select</option>
                        <option value="category">Category</option>
                        <option value="page">Page</option>
                        <option value="custom_link">Custom Link</option>
                        <option value="external_link">External link</option>
                        <option value="blank">Blank</option>
                      </select>
                    </div>
                  </div>
                  <div
                    className="col-md-4"
                    style={Inputs.link_type === 'category' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      <label>Category</label>
                      {Categories.length > 0 && (
                        <DropdownTreeSelect
                          placeholder="Choose"
                          multi={false}
                          id="category-dropdown"
                          data={Categories}
                          onChange={onChangeCategory}
                          mode="radioSelect"
                          className="bootstrap-demo w-100"
                        />
                      )}
                      <input
                        type="hidden"
                        className="form-control"
                        name="category"
                        onBlur={() => validator.current.showMessageFor('category')}
                        value={Inputs.selectedCategoryId}
                      />{' '}
                      {validator.current.message(
                        'Category',
                        Inputs.selectedCategoryId,
                        'required',
                        {
                          className: 'error'
                        }
                      )}
                    </div>
                  </div>
                  <div
                    className="col-md-4"
                    style={Inputs.link_type === 'page' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      <label>Page</label>
                      <select
                        className="form-control"
                        name="page_id"
                        onChange={handleInputChanges}
                        onBlur={() => validator.current.showMessageFor('page')}
                        value={Inputs.page_id}
                      >
                        <option
                          key={''}
                          value={''}
                        >
                          select
                        </option>
                        {Pages.map((item) => (
                          <option
                            key={item.id}
                            value={item.id}
                          >
                            {item.title}
                          </option>
                        ))}
                      </select>
                      {validator.current.message('Page', Inputs.page_id, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div
                    className="col-md-4"
                    style={Inputs.link_type === 'custom_link' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      {' '}
                      <label>Custom Link</label>{' '}
                      <input
                        type="text"
                        className="form-control"
                        name="link"
                        onChange={handleInputChanges}
                        onBlur={() => validator.current.showMessageFor('link')}
                        value={Inputs.link}
                        placeholder="Custom Link"
                      />
                      <label
                        style={{ color: '#505050' }}
                        className="note mt-1"
                      >
                        {' '}
                        {'(Do not include "https://www.example.com/" in link.)'}
                      </label>
                      {validator.current.message('Custom Link', Inputs.link, 'required|noDomain', {
                        className: 'error'
                      })}
                    </div>
                  </div>
                  <div
                    className="col-md-4"
                    style={Inputs.link_type === 'external_link' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      {' '}
                      <label>External Link</label>
                      <input
                        type="text"
                        className="form-control"
                        name="external_link"
                        onChange={handleInputChanges}
                        onBlur={() => validator.current.showMessageFor('external_link')}
                        value={Inputs.external_link}
                        placeholder="External Link"
                      />
                      {validator.current.message(
                        'External Link',
                        Inputs.external_link,
                        'required',
                        {
                          className: 'error'
                        }
                      )}
                    </div>
                  </div>
                  <div
                    className="col-md-4"
                    style={
                      Inputs.link_type === 'blank' || Inputs.link_type === ''
                        ? {}
                        : { display: 'none' }
                    }
                  >
                    <div className="form-group"></div>
                  </div>
                  <div className="col-md-2">
                    <div className="form-group">
                      <label>Link Type</label>
                      <select
                        className="form-control"
                        name="link_type_2"
                        onChange={(e) => handleMenuInputChanges(e, 2)}
                        value={Inputs.link_type_2}
                      >
                        <option value="">Select</option>
                        <option value="category">Category</option>
                        <option value="page">Page</option>
                        <option value="custom_link">Custom Link</option>
                        <option value="external_link">External link</option>
                        <option value="blank">Blank</option>
                      </select>
                    </div>
                  </div>
                  <div
                    className="col-md-4"
                    style={Inputs.link_type_2 === 'category' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      <label>Category</label>
                      {Categories.length > 0 && (
                        <DropdownTreeSelect
                          placeholder="Choose"
                          multi={false}
                          id="category2-dropdown"
                          data={Categories2}
                          onChange={onChangeCategory2}
                          mode="radioSelect"
                          className="bootstrap-demo w-100"
                        />
                      )}
                      <input
                        type="hidden"
                        className="form-control"
                        name="category_2"
                        onBlur={() => validator.current.showMessageFor('category')}
                        value={Inputs.selectedCategoryId_2}
                      />
                      {validator.current.message(
                        'Category',
                        Inputs.selectedCategoryId_2,
                        'required',
                        {
                          className: 'error'
                        }
                      )}
                    </div>
                  </div>

                  <div
                    className="col-md-4"
                    style={Inputs.link_type_2 === 'page' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      <label>Page</label>
                      <select
                        className="form-control"
                        name="page_id_2"
                        onChange={handleInputChanges}
                        value={Inputs.page_id_2}
                      >
                        <option value="">select</option>
                        {Pages.map((item) => (
                          <option
                            key={item.id}
                            value={item.id}
                          >
                            {item.title}
                          </option>
                        ))}
                      </select>
                      {validator.current.message('Page', Inputs.page_id_2, 'required', {
                        className: 'error'
                      })}
                    </div>
                  </div>

                  <div
                    className="col-md-4"
                    style={Inputs.link_type_2 === 'custom_link' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      <label>Custom Link</label>
                      <input
                        type="text"
                        className="form-control"
                        name="link_2"
                        onChange={handleInputChanges}
                        value={Inputs.link_2}
                        placeholder="Custom Link"
                      />
                      <label
                        style={{ color: '#505050' }}
                        className="note mt-1"
                      >
                        {' '}
                        {'(Do not include "https://www.example.com/" in link.)'}
                      </label>
                      {validator.current.message(
                        'Custom Link',
                        Inputs.link_2,
                        'required|noDomain',
                        {
                          className: 'error'
                        }
                      )}
                    </div>
                  </div>

                  <div
                    className="col-md-4"
                    style={Inputs.link_type_2 === 'external_link' ? {} : { display: 'none' }}
                  >
                    <div className="form-group">
                      <label>External Link</label>
                      <input
                        type="text"
                        className="form-control"
                        name="external_link_2"
                        onChange={handleInputChanges}
                        value={Inputs.external_link_2}
                        placeholder="External Link"
                      />
                      {validator.current.message(
                        'External Link',
                        Inputs.external_link_2,
                        'required',
                        {
                          className: 'error'
                        }
                      )}
                    </div>
                  </div>

                  <div
                    className="col-md-4"
                    style={
                      Inputs.link_type_2 === 'blank' || Inputs.link_type_2 === ''
                        ? {}
                        : { display: 'none' }
                    }
                  >
                    <div className="form-group"></div>
                  </div>
                  <div className="col-md-12">
                    <h6 className="mt-1">
                      {' '}
                      Click anywhere on the image to put Button. Re-click the button to remove it
                      from the image.
                    </h6>
                  </div>
                  <div className="col-md-6">
                    <h6 className="mt-2">Desktop Button Position</h6>
                    <div
                      className="mt-1"
                      style={{ position: 'relative', display: 'inline-block' }}
                    >
                      <div style={{ position: 'relative', width: '100%' }}>
                        <img
                          src={
                            DeskImg !== '' && DeskImg !== 'invalid'
                              ? DeskImg
                              : Common.setImage('assets/images/icon/place_holder_1.jpg')
                          }
                          alt="Responsive Click"
                          ref={DesktopImageRef}
                          onClick={handleDesktopImageClick}
                          onMouseMove={handleDesktopImageHover}
                          onMouseLeave={handleDesktopImageLeave}
                          style={{
                            width: '100%',
                            height: 'auto',
                            cursor:
                              Inputs.button_count && Inputs.button_count !== 'null'
                                ? 'crosshair'
                                : 'default',
                            opacity:
                              Inputs.button_count && Inputs.button_count !== 'null' ? 1 : 0.8,
                            display: 'block'
                          }}
                        />
                        {/* Hover indicator showing which button will be placed */}
                        {desktopHoverInfo && desktopHoverInfo.buttonNumber && (
                          <div
                            style={{
                              position: 'absolute',
                              top: `${desktopHoverInfo.yPercent}%`,
                              left: `${desktopHoverInfo.xPercent}%`,
                              transform: 'translate(-50%, -50%)',
                              backgroundColor:
                                desktopHoverInfo.buttonNumber === 1 ? '#FFD700' : '#FF6B6B',
                              color: desktopHoverInfo.buttonNumber === 1 ? '#000' : '#fff',
                              padding: '8px 12px',
                              borderRadius: '6px',
                              fontSize: '12px',
                              fontWeight: 'bold',
                              zIndex: 5,
                              whiteSpace: 'nowrap',
                              border: '2px solid rgba(0,0,0,0.2)',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                              pointerEvents: 'none'
                            }}
                          >
                            Button #{desktopHoverInfo.buttonNumber}
                          </div>
                        )}
                      </div>
                      {(DesktopBtnPosition || Inputs.DesktopbtnX) && Inputs.btn_text && (
                        <div
                          style={{
                            position: 'absolute',
                            top: `${Inputs.DesktopbtnY || DesktopBtnPosition.yPercentDesk}%`,
                            left: `${Inputs.DesktopbtnX || DesktopBtnPosition.xPercentDesk}%`,
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10,
                            textAlign: 'center'
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-dark btn-sm"
                            style={{
                              position: 'relative',
                              fontSize: '8px',
                              marginBottom: '4px',
                              border:
                                currentDesktopButtonBeingPositioned === 1
                                  ? '3px solid #FFD700'
                                  : 'none'
                            }}
                            onClick={() => handleRemoveDesktopButton(1)}
                            title="Button #1 - Click to remove this button"
                          >
                            {Inputs.btn_text}
                          </button>
                          <div
                            style={{
                              fontSize: '10px',
                              color: '#000',
                              backgroundColor: '#FFD700',
                              padding: '2px 6px',
                              borderRadius: '3px',
                              fontWeight: 'bold',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            Button #1
                          </div>
                        </div>
                      )}
                      {(DesktopBtnPosition2 || Inputs.DesktopbtnX2) && Inputs.btn_text_2 && (
                        <div
                          style={{
                            position: 'absolute',
                            top: `${Inputs.DesktopbtnY2 || DesktopBtnPosition2.yPercentDesk}%`,
                            left: `${Inputs.DesktopbtnX2 || DesktopBtnPosition2.xPercentDesk}%`,
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10,
                            textAlign: 'center'
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-dark btn-sm"
                            style={{
                              position: 'relative',
                              fontSize: '8px',
                              marginBottom: '4px',
                              border:
                                currentDesktopButtonBeingPositioned === 2
                                  ? '3px solid #FF6B6B'
                                  : 'none'
                            }}
                            onClick={() => handleRemoveDesktopButton(2)}
                            title="Button #2 - Click to remove this button"
                          >
                            {Inputs.btn_text_2}
                          </button>
                          <div
                            style={{
                              fontSize: '10px',
                              color: '#fff',
                              backgroundColor: '#FF6B6B',
                              padding: '2px 6px',
                              borderRadius: '3px',
                              fontWeight: 'bold',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            Button #2
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-md-6">
                    <h6>Set Mobile Button Position</h6>
                    <div
                      className="mt-1"
                      style={{ position: 'relative', display: 'inline-block' }}
                    >
                      <div style={{ position: 'relative', width: '100%' }}>
                        <img
                          src={
                            MobileImg !== ''
                              ? MobileImg
                              : Common.setImage('assets/images/icon/place_holder_1.jpg')
                          }
                          alt="Responsive Click"
                          ref={MobileImageRef}
                          onClick={handleMobileImageClick}
                          onMouseMove={handleMobileImageHover}
                          onMouseLeave={handleMobileImageLeave}
                          style={{
                            width: '100%',
                            height: 'auto',
                            cursor:
                              Inputs.button_count && Inputs.button_count !== 'null'
                                ? 'crosshair'
                                : 'default',
                            opacity:
                              Inputs.button_count && Inputs.button_count !== 'null' ? 1 : 0.8,
                            display: 'block'
                          }}
                        />
                        {/* Hover indicator showing which button will be placed */}
                        {mobileHoverInfo && mobileHoverInfo.buttonNumber && (
                          <div
                            style={{
                              position: 'absolute',
                              top: `${mobileHoverInfo.yPercent}%`,
                              left: `${mobileHoverInfo.xPercent}%`,
                              transform: 'translate(-50%, -50%)',
                              backgroundColor:
                                mobileHoverInfo.buttonNumber === 1 ? '#FFD700' : '#FF6B6B',
                              color: mobileHoverInfo.buttonNumber === 1 ? '#000' : '#fff',
                              padding: '8px 12px',
                              borderRadius: '6px',
                              fontSize: '12px',
                              fontWeight: 'bold',
                              zIndex: 5,
                              whiteSpace: 'nowrap',
                              border: '2px solid rgba(0,0,0,0.2)',
                              boxShadow: '0 2px 8px rgba(0,0,0,0.15)',
                              pointerEvents: 'none'
                            }}
                          >
                            Button #{mobileHoverInfo.buttonNumber}
                          </div>
                        )}
                      </div>
                      {(MobileBtnPosition || Inputs.MobilebtnX) && Inputs.btn_text && (
                        <div
                          style={{
                            position: 'absolute',
                            top: `${Inputs.MobilebtnY || MobileBtnPosition.yPercentMob}%`,
                            left: `${Inputs.MobilebtnX || MobileBtnPosition.xPercentMob}%`,
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10,
                            textAlign: 'center'
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-dark btn-sm"
                            style={{
                              position: 'relative',
                              fontSize: '8px',
                              marginBottom: '4px',
                              border:
                                currentMobileButtonBeingPositioned === 1
                                  ? '3px solid #FFD700'
                                  : 'none'
                            }}
                            onClick={() => handleRemoveMobileButton(1)}
                            title="Button #1 - Click to remove this button"
                          >
                            {Inputs.btn_text}
                          </button>
                          <div
                            style={{
                              fontSize: '10px',
                              color: '#000',
                              backgroundColor: '#FFD700',
                              padding: '2px 6px',
                              borderRadius: '3px',
                              fontWeight: 'bold',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            Button #1
                          </div>
                        </div>
                      )}
                      {(MobileBtnPosition2 || Inputs.MobilebtnX2) && Inputs.btn_text_2 && (
                        <div
                          style={{
                            position: 'absolute',
                            top: `${Inputs.MobilebtnY2 || MobileBtnPosition2.yPercentMob}%`,
                            left: `${Inputs.MobilebtnX2 || MobileBtnPosition2.xPercentMob}%`,
                            transform: 'translate(-50%, -50%)',
                            zIndex: 10,
                            textAlign: 'center'
                          }}
                        >
                          <button
                            type="button"
                            className="btn btn-dark btn-sm"
                            style={{
                              position: 'relative',
                              fontSize: '8px',
                              marginBottom: '4px',
                              border:
                                currentMobileButtonBeingPositioned === 2
                                  ? '3px solid #FF6B6B'
                                  : 'none'
                            }}
                            onClick={() => handleRemoveMobileButton(2)}
                            title="Button #2 - Click to remove this button"
                          >
                            {Inputs.btn_text_2}
                          </button>
                          <div
                            style={{
                              fontSize: '10px',
                              color: '#fff',
                              backgroundColor: '#FF6B6B',
                              padding: '2px 6px',
                              borderRadius: '3px',
                              fontWeight: 'bold',
                              whiteSpace: 'nowrap'
                            }}
                          >
                            Button #2
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
                <div className="row mt-3">
                  <div className="col-md-6">
                    <button
                      type="button"
                      onClick={SubmitForm}
                      className="btn btn-custom text-white mr-2"
                    >
                      {' '}
                      Submit{' '}
                    </button>
                    <Link
                      to="/widgets/banner"
                      className="btn btn-primary"
                    >
                      Cancel
                    </Link>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default AddBanner
